import { EditFilled } from "@ant-design/icons";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.css";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import {
  chucvuListURL,
  exportExcelUser,
  listBophansudung,
  teamListURL,
  userCreateURL,
  userURL,
  usersListURLV2,
} from "../constants";
import { authAxios } from "../utils";
import { openNotificationWithIcon } from "./Function";

const cookies = new Cookies();
const { Search } = Input;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
const fetchUserInfo = (userId) => {
  return authAxios(cookies.get("token")).get(userURL(userId));
};

const fetchListTeam = () => {
  return authAxios(cookies.get("token")).get(teamListURL);
};

const EditUserInfo = (newDataUser, dataOld, dataUser) => {
  let getFilterData = dataUser
    .filter((item) => item.id !== dataOld.id)
    .filter(
      (item) =>
        item.username === newDataUser.tendangnhap ||
        item.email === newDataUser.email,
    );
  if (getFilterData.length > 0) {
    openNotificationWithIcon(
      "error",
      "Cảnh báo",
      "Trùng tài khoản đã có. Yêu cầu kiểm tra lại tên đăng nhập, mã số nhân viên và email.",
    );
    return false;
  }

  let FormData = require("form-data");
  let data = new FormData();
  data.append("username", newDataUser.tendangnhap);
  data.append("first_name", newDataUser.ten);
  data.append("last_name", newDataUser.ho);
  // data.append('msnv', newDataUser.msnv)
  data.append("email", newDataUser.email);
  data.append("team", newDataUser.team);
  data.append("chucvu", newDataUser.chucvu);
  data.append("nhomquyen", newDataUser.nhomquyen);
  newDataUser.department ? data.append("bophan", newDataUser.department) : null;
  data.append("is_active", newDataUser.is_active);
  data.append("is_superuser", dataOld.is_superuser);

  return authAxios(cookies.get("token"))
    .put(userURL(dataOld.id), data)
    .then((res) => {
      if (res.data.error) {
        const dataError = Object.entries(res.data.error).map(([key, value]) => (
          <p>{value}</p>
        ));
        openNotificationWithIcon("error", "Lỗi", dataError);
        return false;
      }
    })
    .catch((err) => {
      openNotificationWithIcon("error", "Lỗi", err);
      return false;
    });
};
const CreateUserInfo = (newDataUser) => {
  let FormData = require("form-data");
  let data = new FormData();
  data.append("username", newDataUser.tendangnhap);
  data.append("first_name", newDataUser.ten);
  data.append("last_name", newDataUser.ho);
  data.append("msnv", newDataUser.msnv);
  data.append("email", newDataUser.email);
  data.append("team", newDataUser.team);
  data.append("chucvu", newDataUser.chucvu);
  data.append("nhomquyen", newDataUser.nhomquyen);
  data.append("is_active", true);
  newDataUser.department ? data.append("bophan", newDataUser.department) : null;
  return authAxios(cookies.get("token")).post(userCreateURL, data);
};
async function waitForUserInfo(userId) {
  let getUserInfo = await fetchUserInfo(userId);
  let listTeam = await fetchListTeam();
  return [getUserInfo, listTeam];
}
async function waitForEditUserInfo(newDataUser, dataOld, dataUser) {
  let res = await EditUserInfo(newDataUser, dataOld, dataUser);
  return res;
}
// async function waitForSetPermission(newDataUser,dataOld, lsBoPhanXuLy) {
//     let res = await SetPermission(newDataUser,dataOld, lsBoPhanXuLy);
//     return res
// }
async function waitForCreateUserInfo(newDataUser) {
  let res = await CreateUserInfo(newDataUser);
  return res;
}
const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef();
  useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};

const ModalFormCreateUser = ({
  visible,
  onCancel,
  listTeam,
  listChucVu,
  ls_permission,
  list_bophansudung,
}) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onFinish = (values) => {
    if (values.msnv == 0) {
      openNotificationWithIcon("error", "Lỗi", "MSNV không hợp lệ.");
      setLoadingModal(false);
      return false;
    }
    waitForCreateUserInfo(values)
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => <p>{value}</p>,
          );
          openNotificationWithIcon("error", "Lỗi", dataError);
          setLoadingModal(false);
        } else {
          onCancelModal(true);
          setLoadingModal(false);
        }
      })
      .catch((err) => {
        openNotificationWithIcon("error", "Lỗi", err);
      });
  };
  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    onCancel(value);
  };
  return (
    <Modal
      title="Tạo người dùng mới"
      open={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      width={800}
      forceRender
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormCreate"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item
                name="tendangnhap"
                label="Tên đăng nhập"
                rules={[{ required: true }]}
              >
                <Input placeholder="Nhập tên đăng nhập" />
              </Form.Item>

              <Form.Item
                name="ho"
                label="Họ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Nhập họ" />
              </Form.Item>
              <Form.Item
                name="ten"
                label="Tên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Nhập tên" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Vui lòng nhập đúng định dạng E-mail!",
                  },
                  {
                    required: true,
                    message: "Vui lòng nhập E-mail!",
                  },
                ]}
              >
                <Input placeholder="Nhập email" />
              </Form.Item>
            </Col>
            <Col sm={1}></Col>
            <Col sm={10} offset={1}>
              <Form.Item
                name="msnv"
                label="Mã số nhân viên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder="Nhập mã số sinh viên"
                  type={"number"}
                  min={1}
                  onKeyDown={(evt) =>
                    evt.keyCode === 8 || evt.keyCode === 46
                      ? true
                      : (isNaN(Number(evt.key)) ||
                          ["e", "-", ".", " "].includes(evt.key)) &&
                        evt.preventDefault()
                  }
                />
              </Form.Item>
              <Form.Item name="department" label="Phòng ban">
                <Select placeholder="Chọn phòng ban">
                  {(list_bophansudung ?? []).map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="team"
                label="Team"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Chọn team">
                  {listTeam.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="chucvu"
                label="Chức vụ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Chọn chức vụ">
                  {listChucVu.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="nhomquyen" label="Nhóm quyền bổ sung">
                <Select placeholder="Chọn nhóm quyền" allowClear>
                  {ls_permission
                    ? ls_permission.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))
                    : null}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row>
          <h4 style={{ color: "#a91c1c" }}>Lưu ý:</h4>
        </Row>
        <Row>
          <h5 style={{ color: "#73879C" }}>
            1. Các trường có dấu (*) là bắt buộc.
          </h5>
          <h5 style={{ color: "#73879C" }}>
            2. Phân quyền người dùng cho Bộ phận xử lý được thực hiện ở chức
            năng Chỉnh sửa trong Danh sách bộ phận xử lý.
          </h5>
        </Row>
      </Spin>
    </Modal>
  );
};

const ModalFormEditUser = ({
  visible,
  onCancel,
  dataUserEdit,
  listTeam,
  listChucVu,
  ls_permission,
  list_bophansudung,
}) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [isActive, setIsActive] = useState(true);
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onFinish = (values) => {
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: {} })
      .then((res) => {
        waitForEditUserInfo(values, dataUserEdit, res.data).then((res) => {
          // res == false ? null : onCancelModal(true)
          if (res != false) {
            onCancelModal(true);
          }
          setLoadingModal(false);
        });
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (dataUserEdit != undefined && dataUserEdit != "") {
      setIsActive(dataUserEdit.is_active);
      form.setFieldsValue({
        tendangnhap: dataUserEdit.username,
        department: dataUserEdit.bophan,
        // msnv:dataUserEdit.msnv,
        ten: dataUserEdit.first_name,
        ho: dataUserEdit.last_name,
        email: dataUserEdit.email,
        team: dataUserEdit.team,
        chucvu: dataUserEdit.chucvu,
        nhomquyen:
          dataUserEdit.ls_permission.length != 0
            ? dataUserEdit.ls_permission[0]
            : null,
        is_active: dataUserEdit.is_active,
      });
    }
  }, [dataUserEdit]);

  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    onCancel(value);
  };
  const setActive = (e) => {
    setIsActive(e.target.checked);
    form.setFieldsValue({
      is_active: e.target.checked,
    });
  };
  return (
    <Modal
      title="Chỉnh sửa thông tin người dùng"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      okText="Lưu"
      width={800}
      forceRender
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormEdit"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item
                name="tendangnhap"
                label="Tên đăng nhập"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="ho"
                label="Họ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="ten"
                label="Tên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="is_active" label="Kích hoạt">
                <Checkbox
                  defaultChecked={dataUserEdit.is_active}
                  checked={isActive}
                  onChange={(e) => setActive(e)}
                />
              </Form.Item>
            </Col>
            <Col sm={10} offset={1}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Vui lòng nhập đúng định dạng E-mail!",
                  },
                  {
                    required: true,
                    message: "Vui lòng nhập E-mail!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="department" label="Phòng ban">
                <Select placeholder="Chọn phòng ban">
                  {list_bophansudung.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="team"
                label="Team"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select>
                  {listTeam.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="chucvu"
                label="Chức vụ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select>
                  {listChucVu.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="nhomquyen" label="Nhóm quyền bổ sung">
                <Select placeholder="Chọn nhóm quyền" allowClear>
                  {ls_permission
                    ? ls_permission.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))
                    : null}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

class SettingsUsers extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: 0,
    pagination: { pageSize: 10, current: 1, page: 1 },
    visibleFormEditUserModal: false,
    visibleFormSetPermissionUserModal: false,
    idUserEdit: "",
    dataUserEdit: "",
    listTeam: [],
    listChucVu: [],
    list_bophansudung: [],
  };
  componentDidMount() {
    this.fetchListUser({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "descend",
    });
    this.fetchListChucVu();
    this.fetchBophansudung();
    this.fetchListTeam();
  }
  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    this.fetchListUser({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      search: this.state.searchKey,
    });
  };
  fetchBophansudung() {
    authAxios(cookies.get("token"))
      .get(listBophansudung, {
        params: { is_active: true, page: 1, page_size: 100 },
      })
      .then((res) => {
        this.setState({
          list_bophansudung: res.data.results.filter(
            (item) => item.is_active == true,
          ),
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }

  fetchListUser = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: params })
      .then((res) => {
        this.setState({
          data: res.data,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  fetchListChucVu = () => {
    authAxios(cookies.get("token"))
      .get(chucvuListURL)
      .then((res) => {
        const listChucVuActive = res.data.filter(
          (item) => item.is_active == true,
        );
        // console.log(res.data);
        this.setState({ listChucVu: listChucVuActive });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  fetchListTeam = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      // .get(teamListURL)
      .get(teamListURL, { params: params })
      .then((res) => {
        // console.log(res.data);
        const listTeamActive = res.data.filter(
          (item) => item.is_active == true,
        );
        this.setState({ listTeam: listTeamActive });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  SearchUserList = (value, event) => {
    // console.log(value);
    let { sortKey, sortDirection, pageSize } = this.state;
    const pager = { ...this.state.pagination };
    pager.current = 1;
    pager.page = 1;
    let key =
      value === "Khóa" ? "false" : value === "Kích hoạt" ? "true" : value;
    this.setState({ searchKey: key, pagination: pager });
    this.fetchListUser({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "ascend",
      search: key,
    });
  };
  editUserInfo = (idUser) => {
    waitForUserInfo(idUser).then((res) => {
      const listTeamActive = res[1].data.filter(
        (item) => item.is_active == true,
      );
      this.setState({
        idUserEdit: idUser,
        dataUserEdit: res[0].data,
        listTeam: listTeamActive,
        visibleFormEditUserModal: true,
      });
    });
  };
  showCreateUserModal = () => {
    this.setState({ visibleFormCreateUserModal: true });
  };
  showSetPermissionUserModal = (idUser) => {
    waitForUserInfo(idUser).then((res) => {
      this.setState({
        idUserEdit: idUser,
        dataUserEdit: res[0].data,
        visibleFormSetPermissionUserModal: true,
      });
    });
  };
  hideEditUserModal = (value) => {
    this.setState({
      idUserEdit: "",
      visibleFormEditUserModal: false,
      dataUserEdit: "",
    });
    if (value === true) {
      this.fetchListUser({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin người dùng ",
      );
    }
  };

  hideSetPermissionUserModal = (value) => {
    this.setState({
      idUserEdit: "",
      visibleFormSetPermissionUserModal: false,
      dataUserEdit: "",
    });
    if (value === true) {
      this.fetchListUser({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin người dùng ",
      );
    }
  };
  hideCreateUserModal = (value) => {
    this.setState({ visibleFormCreateUserModal: false, dataUserCreate: "" });
    if (value === true) {
      this.fetchListUser({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon("success", "Thành công", "Tạo mới người dùng ");
    }
  };

  fileDownload = () => {
    const fnFileDownload = require("js-file-download");
    const filename =
      "HR_DanhSach_User" +
      "_" +
      moment(new Date()).format("YYYYMMDD") +
      ".xlsx";
    authAxios(cookies.get("token"))
      .get(exportExcelUser, { responseType: "blob" })
      .then((res) => {
        fnFileDownload(res.data, filename);
      });
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      visibleFormEditUserModal,
      visibleFormCreateUserModal,
      visibleFormSetPermissionUserModal,
    } = this.state;
    let { ls_permission } = this.props;
    const columns = [
      {
        title: "STT",
        dataIndex: "id",
        key: "index",
        width: "3%",
        render: (value, item, index) =>
          ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
        sortDirections: ["descend", "ascend", "descend"],
        fixed: "left",
      },
      {
        title: "Tên đăng nhập",
        dataIndex: "username",
        key: "username",
        sorter: (a) => a,
        fixed: "left",
      },
      {
        title: "MSNV",
        dataIndex: "msnv",
        key: "msnv",
        sorter: (a) => a,
        width: 100,
      },
      {
        title: "Tên",
        dataIndex: "first_name",
        key: "first_name",
      },
      {
        title: "Họ",
        dataIndex: "last_name",
        key: "last_name",
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Thời gian tạo",
        dataIndex: "date_joined",
        key: "date_joined",
        render: (text) => (text ? moment(text).format("L") : ""),
      },
      {
        title: "Thời gian khóa",
        dataIndex: "date_lock",
        key: "date_lock",
        render: (text) => (text ? moment(text).format("L") : ""),
      },
      {
        title: "Phòng ban",
        dataIndex: "bophan",
        key: "bophan",
        render: (text) =>
          this?.state?.list_bophansudung?.find((item) => item?.id === text)
            ?.name ?? "",
      },
      {
        title: "Team",
        dataIndex: "team",
        key: "team",
        render: (text) =>
          this.state.listTeam
            .filter((item) => item.id === text)
            .map((item, index) => item.name)[0],
      },
      {
        title: "Chức vụ",
        dataIndex: "chucvu",
        key: "chucvu",
        render: (text) =>
          this.state.listChucVu
            .filter((item) => item.id === text)
            .map((item, index) => item.name)[0],
      },

      {
        title: "Thay đổi lần cuối",
        dataIndex: "updated",
        key: "updated",
        render: (text) => (text ? moment(text).format("L") : ""),
      },
      {
        title: "Lần cuối đăng nhập",
        dataIndex: "last_login",
        key: "last_login",
        render: (text) =>
          text ? moment(text).format("L") : "Chưa từng đăng nhập",
      },
      {
        title: "Trạng thái",
        dataIndex: "is_active",
        key: "is_active",
        render: (text) => (text ? "Kích hoạt" : "Khóa"),
      },
      {
        width: "4%",
        title: "Thao tác",
        key: "operation",
        fixed: "right",
        render: (text, record) => (
          <Space size="small">
            <Tooltip
              placement="bottomRight"
              title={"Chỉnh sửa thông tin người dùng"}
            >
              <Button
                onClick={() => this.editUserInfo(record.id)}
                type={"primary"}
              >
                <EditFilled />
              </Button>
            </Tooltip>
          </Space>
        ),
      },
    ];

    return (
      <>
        <Row>
          <Col sm={16} style={{ float: "left" }}>
            <Button
              type={"primary"}
              danger
              style={{ marginBottom: 15 }}
              onClick={this.showCreateUserModal}
            >
              <PlusOutlined /> Thêm người dùng mới
            </Button>
            <Button
              type={"primary"}
              className={"btnGreen"}
              onClick={this.fileDownload}
            >
              Xuất excel
            </Button>
          </Col>
          <Col sm={8} style={{ float: "right" }}>
            <Search
              placeholder="Nhập từ khóa tìm kiếm"
              enterButton="Tìm kiếm"
              size="normal"
              onSearch={this.SearchUserList}
            />
          </Col>
        </Row>
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          rowKey="id"
          scroll={{ x: 1700, y: 600 }}
          className="styleTable_1"
          onChange={this.handleChange}
          size="small"
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            size: "default",
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
        <ModalFormEditUser
          list_bophansudung={this.state.list_bophansudung}
          visible={visibleFormEditUserModal}
          onCancel={this.hideEditUserModal}
          dataUserEdit={this.state.dataUserEdit}
          listTeam={this.state.listTeam}
          listChucVu={this.state.listChucVu}
          ls_permission={ls_permission}
        />
        <ModalFormCreateUser
          list_bophansudung={this.state.list_bophansudung}
          visible={visibleFormCreateUserModal}
          onCancel={this.hideCreateUserModal}
          listTeam={this.state.listTeam}
          listChucVu={this.state.listChucVu}
          ls_permission={ls_permission}
        />
      </>
    );
  }
}

SettingsUsers.propTypes = {
  ls_permission: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    ls_permission: state.user.ls_permission,
  };
};

export default connect(mapStateToProps)(SettingsUsers);
